import { TerminalReader } from '../../components/terminal-settings/terminal-settings.data';
import { readCommonSettings, updateCommonSettings } from './common-settings.util';

export function readRememberedTerminalReaderId(): string | null {
  const readerId = readCommonSettings().terminalReaderId;
  return typeof readerId === 'string' && readerId.trim() ? readerId : null;
}

export function rememberTerminalReaderId(readerId: string): void {
  const reader = String(readerId || '').trim();
  if (reader) {
    updateCommonSettings({ terminalReaderId: reader });
  }
}

/**
 * Reader to pre-select at checkout: the remembered one while it is online, else the
 * first online reader, else the first reader (so the offline notice can show).
 * A missing reader list picks nothing.
 */
export function pickTerminalReaderId(
  readers: TerminalReader[] | null | undefined,
  rememberedId: string | null
): string {
  const list = readers ?? [];
  const online = list.filter(reader => reader?.status === 'online');
  const remembered = online.find(reader => reader.id === rememberedId);
  return remembered?.id ?? online[0]?.id ?? list[0]?.id ?? '';
}

/**
 * Picks the checkout reader and remembers it when it is online, so an offline
 * remembered reader stops being the default once another one takes over.
 */
export function selectCheckoutTerminalReaderId(
  readers: TerminalReader[] | null | undefined
): string {
  const readerId = pickTerminalReaderId(readers, readRememberedTerminalReaderId());
  if ((readers ?? []).some(reader => reader?.id === readerId && reader.status === 'online')) {
    rememberTerminalReaderId(readerId);
  }
  return readerId;
}
